import { render, staticRenderFns } from "./ConsentFinancialPolicy.vue?vue&type=template&id=07c96fd9"
import script from "./ConsentFinancialPolicy.vue?vue&type=script&lang=js"
export * from "./ConsentFinancialPolicy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports